import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { AppContext } from '../../App';

const Feedback = () => {
  const { feedback, setFeedback } = React.useContext(AppContext);
  return (
    <Snackbar
      id="snackbar"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={feedback.open}
      onClose={() => setFeedback({ open: false, message: '' })}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      autoHideDuration={3000}
      message={<span id="message-id">{feedback.message}</span>}
    />
  );
};

export default Feedback;
